export var BucketTypes;
(function (BucketTypes) {
    BucketTypes["EQI"] = "EQI";
    BucketTypes["QNT"] = "QNT";
    BucketTypes["STD"] = "STD";
    BucketTypes["GPG"] = "GPG";
    BucketTypes["APG"] = "APG";
    BucketTypes["JNK"] = "JNK";
})(BucketTypes || (BucketTypes = {}));
